import directusServer from "./directus/directusGraphQLInstance"
import { rethrowIfDatabaseUnavailable } from "./errors/database"

const toSlugArray = (value?: string | string[]) => {
  if (!value) return []
  const list = Array.isArray(value) ? value : value.split(",")
  return list.map((v) => v.trim()).filter(Boolean)
}

const getAllPostsPages = async ({
  category,
  categoryExclude,
  postsPerPage = 8,
}: {
  category?: string | string[]
  categoryExclude?: string | string[]
  postsPerPage?: number
} = {}) => {
  try {
    const categorySlugs = toSlugArray(category)
    const excludedCategorySlugs = toSlugArray(categoryExclude)
    const hasCategoryFilter = categorySlugs.length > 0
    const hasCategoryExclusion = excludedCategorySlugs.length > 0
    const response = await directusServer.query(
      `query allBlogPostsPages${
        hasCategoryFilter || hasCategoryExclusion
          ? `(${[
              hasCategoryFilter ? "$categories: [String!]" : "",
              hasCategoryExclusion ? "$excludedCategories: [String!]" : "",
            ]
              .filter(Boolean)
              .join(", ")})`
          : ""
      } {
					posts_aggregated(
						filter: {
							status: { _eq: "published" }
							${
                hasCategoryFilter || hasCategoryExclusion
                  ? `category: {
								${hasCategoryFilter ? "category_id: { slug: { _in: $categories } }" : ""}
								${hasCategoryExclusion ? "_none: { category_id: { slug: { _in: $excludedCategories } } }" : ""}
							}`
                  : ""
              }
						}
					) {
						count {
							id
						}
					}
				}`,
      {
        ...(hasCategoryFilter && { categories: categorySlugs }),
        ...(hasCategoryExclusion && {
          excludedCategories: excludedCategorySlugs,
        }),
      }
    )

    const totalPosts = response.posts_aggregated[0]?.count?.id
    const totalPages = Math.ceil(totalPosts / postsPerPage)
    return {
      totalPages: totalPages,
      totalPosts: totalPosts,
    }
  } catch (error) {
    rethrowIfDatabaseUnavailable(error)
    console.error(error)
    return null
  }
}

export default getAllPostsPages
